import { render, staticRenderFns } from "./EmployeeSalaryGraph.vue?vue&type=template&id=5f6871de&"
import script from "./EmployeeSalaryGraph.vue?vue&type=script&lang=js&"
export * from "./EmployeeSalaryGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports